import React from "react";
import { useEffect, useState } from "react";
import Image from "next/image";
import Head from "next/head";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import styles from "./index.module.scss";
import one from "@images/home/22@2x.png";
import { getCateDetail, getArticleDetail, getCateList, getPostList } from "@/service/index";
import Layout from "@/components/layout";
import buriedSdk from '@/utils/zz-buried/index'
import Link from "next/link";
import { Collapse } from "antd";
import { useRouter } from "next/router";
import { useWidth } from "@/utils/resize";
import dayjs from "dayjs";
import { getLangLink } from "@/utils/lang";
import Pagination from "@/components/Pagination";
import PostDetail from '@/components/PostDetail/detail'
const PostsList: NextPage<{
  list: any[];
  total: number;
  type: string;
  actived: any;
  activedCate: string;
  current: number;
  size: number;
  resDetail: any;
  menu: Array<any>;
  dataInfo: any,
  isAllList: boolean
}> = (props) => {
  const { i18n } = useTranslation("blog");
  const { list, total, current, size , menu, type, actived, activedCate, resDetail, isAllList } = props;
  const cateDetatil = resDetail?.data || {}
  const router = useRouter();
  const { locales, locale: activeLocale } = router;
  const dataDetail: any = props?.dataInfo || {};

  const { width, display } = useWidth();
  const t = (key, target="blog") => {
    const lang = i18n?.language || 'en'
    const obj = i18n?.options?.resources || {} as any
    const data = obj[lang] || {}
    const info = data[target] || {}
    return info[key]
  }
  const handleMobileClose = () => {
    $('.menuPost').removeClass('block')
    $('.menuPost').attr({style:"left: -100"})
    $('.maskPost').removeClass('block')
    $('.maskPost').attr({style:"z-index:-1"})
  }
  const clickAbled = (text, url) => {
    buriedSdk.buried({
      event: `按钮点击`,
      scene: `${text}`,
      URL: window.location.href
    })
    window.open(
      url,
      '_blank'
    )
  }
  const handleMobileOpen = () => {
    $('.menuPost').addClass('block')
    $('.menuPost').attr({style:"left: 0"})
    $('.maskPost').addClass('block')
    $('.maskPost').attr({style:"z-index:9"})
  }
  /**
   * @description: rc-paginaion里面的方法 作用：修改分页里面的<a>标签让他拥有href 利于seo
   * @param {any} current
   * @param {any} type
   * @param {any} element
   * @return {*}
   */

  const [xValue, setXValue] = useState(false); //false 表示大于768px
  //解决768px blog主图不能全屏
  useEffect(() => {
    const handleResize = (setXValue: any) => {
      if (typeof window !== "undefined") {
        var screenW = document.body.clientWidth;
        if (screenW <= 768) {
          setXValue(true);
        } else {
          setXValue(false);
        }
      }
    };
    handleResize(setXValue);
    window.addEventListener("resize", (e) => handleResize(setXValue), false);
    return () => {
      window.addEventListener("resize", (e) => handleResize(setXValue), false);
    };
  }, []);
  const { Panel } = Collapse;
  return (
    type == 'list' ? <div>
      <Layout header={true} footer={true}>
        {
          isAllList ? <Head>
            <title>{t('title', 'blog')}</title>
            <meta name="description" content={t('description')} />
            <meta name="keyword" content={t('keyword')} />
          </Head> : <Head>
            <title>{cateDetatil.title}</title>
            <meta name="description" content={cateDetatil.desc}/>
          </Head>
        }
        <div className={styles.posts + " relative "}>
          {/* 版心 */}
          <div className={styles.container + " defeaultContainer"}>
            <div className={`text-[14px] leading-[21px] ${styles['break-box']}`}>
              <a
                href={process.env.portalUrl + getLangLink("", activeLocale)}
                className="!text-[#708096] hover:!text-[#ff3e5f]"
              >
                {t("Home")}
              </a>
              <span className="text-[#708096]"> / </span>
              <span className="text-[#2E384E]">{t("Posts", 'nav')}</span>
            </div>
            <div className={styles.containerBanner + " animate-box"}>
              {
                isAllList ? <div className="text-center" style={{fontFamily: "Poppins-Medium,Poppins"}}>
                  <div className="ant text-[40px] lg1024:text-[24px] text-[#0e1527] font-bold mb-[24px]">{t('allArticleTitle')}</div>
                  <div className="ant text-[16px] lg1024:text-[12px] text-[#353535]">{t('allArticleContent')}</div>
                  </div> :
                  <div>
                    <div className={styles.title + " "}>{cateDetatil.introduceTitle}</div>
                    <div className={styles.title1}>
                      {cateDetatil.introduce}
                    </div>
                    <div>
                      <a onClick={()=> clickAbled('文章导航页-Start Free Trial按钮',width > 1024 ? process.env.portalUrl + '/home' : process.env.mobileUrl)}
                         className={`${styles.get} ant`}>
                        {t('START FREE TRIAL', 'home')}
                      </a>
                    </div>
                  </div>
              }
            </div>
            {/* 渲染报告列表 */}
            <div className={styles.listBox}>
            {width < 1024 ? (
              <li className="ml-[2.8%] minlg1024:hidden flex items-center"  onClick={handleMobileOpen}>
                <span className={styles.mobileOpen}>
                  <i className="iconfont icon-a-47caidan !text-[24px]"></i>
                </span> <span className="ml-[6px] truncate"> {cateDetatil?.name} </span>
              </li>
            ) : null}
            <div className={`${styles['modal-mask']} maskPost`}></div>
            <div className={`${styles.listMenu} menuPost`}>
              <div className="relative">
                <span className={styles.mobileClose} onClick={handleMobileClose}>
                      <svg
                        className="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2243"
                        width="200"
                        height="200"
                      >
                        <path
                          d="M283.456 223.338667l2.709333 2.496L512 451.626667l225.834667-225.813334a42.666667 42.666667 0 0 1 62.826666 57.621334l-2.496 2.709333L572.373333 512l225.813334 225.834667a42.666667 42.666667 0 0 1-57.621334 62.826666l-2.709333-2.496L512 572.373333 286.165333 798.165333a42.666667 42.666667 0 0 1-62.826666-57.621333l2.496-2.709333L451.626667 512 225.834667 286.165333a42.666667 42.666667 0 0 1 57.621333-62.826666z"
                          p-id="2244"
                          fill="#2E384E"
                        ></path>
                      </svg>
                    </span>
                <a className={`ml-[10px] text-[16px] font-bold !text-[#000] ${isAllList ? '!text-[#FF3E5F]' : ''}`}
                   href={getLangLink('/posts')}>{t('allArticle')}</a>
                <Collapse accordion expandIconPosition="end" defaultActiveKey={actived} ghost bordered={false} >
              {menu && menu.map((item, index) => {
                return (<Panel header={item.name} key={item.id}>
                {item.children && item.children.map((item, index) => (<div key={item.id} className={styles.listA}><a className={`${activedCate == item.url ? styles.atived : ''}`} href={`/posts/category/${item.url}`}>{item.name}</a></div>))}
              </Panel>)
              })}
            </Collapse>
              </div>
            </div>
            <div className={styles.listRight}>
              <div className={styles.postList}>
                {list && list.length > 0
                  ? list.map((item, index) => (
                    <div key={index}>
                      {
                        isAllList ?  <a className="px-[28px] lg1024:px-[14px] lg1024:text-[14px] font-bold hover:!text-[#ff3e5f]"
                                        href={getLangLink(`/posts/category/${item.categorySeoUrl}`, activeLocale)}
                        >
                          {item.categoryName2}
                        </a> : null
                      }
                      <a
                        href={getLangLink(`/posts/${item.seoUrl}`, activeLocale)}
                        title={item.seoTitle}
                        className={styles.blogItem}
                      >
                        <div className={styles.item} key={index}>
                          <div className={`${styles.title}`}>{item.title}</div>
                          <div
                            className={
                              styles.desc +
                              " text-[16px] lg1024:!min-h-0 lg1024:!text-[14px] lg1024:!leading-[20px]"
                            }
                          >
                            {item.desc}
                          </div>
                          <div className="text-[#666] mt-[10px] text-[11px]">
                            { item.author ? <span className="mr-[10px]">{item.author}</span> : null }
                            {item.createTime}
                          </div>
                        </div>
                      </a>
                    </div>
                    ))
                  : null}
              </div>
              <div className="py-[26px] mt-[30px] bg-[#ffffff] rounded-[8px] minlg1024:pb-[74px] lg1024:pb-[27px]">
                <Pagination
                  type={'params'}
                  current={Number(current)}
                  total={total}
                  size={size}
                  pageSizeOptions={[10, 20, 30]}
                ></Pagination>
              </div>
            </div>
            </div>
          </div>
        </div>
      </Layout>
    </div> : <PostDetail dataDetail={dataDetail} width={width} t={t}></PostDetail>
  );
};
export const getServerSideProps: GetServerSideProps = async (context) => {
  type paramOb = {
    [propsName: string]: any
  }
  const { locale, params, query }  = context;
  const isAllList = !params?.slug
  const type = (params?.slug?.length && params?.slug[0] === 'category') || !params?.slug ? 'list': 'detail'
  /**
   * @description: 获取bolg列表
   * @return {*}
   */
  let res : any = {}
  let resDetail: any = {}
  let dataInfo = {
    post: {},
    previousPost: null,
    nextPost: null,
    readMores: [],
    detailList: []
  }
  let menu: any = []
  let actived = [] as any
  let activedCate = ''
  if (type == 'list') {
    res = await getCateList({
      language: locale,
      context,
    });


  } else {
    let targetUrl = (params as paramOb)?.slug[0]?.split('#')[0]
    console.log(targetUrl, 'res1111')

    res = await getArticleDetail({
      url: targetUrl,
      language: locale,
      context,
    });
  }
  let total = 0;
  let blogs: any[] = [];
  let list = []
  let current: any = query.pageNum ? query.pageNum : 1;
  let size: any = query.pageSize ? query.pageSize : 20;

  if (res && res?.code == 0 && type == 'list') {
    menu = res?.data.filter(item => item.children?.length)
    if (params?.slug && params?.slug[1]) {
      resDetail = await getCateDetail({
        language: locale,
        url: params?.slug[1],
        context,
      });
      actived = resDetail.data.parentId
      activedCate = resDetail.data.url

    } else {
      if (!isAllList) {
        actived = menu[0] ? [menu[0].id] : ''
        activedCate = menu[0] ? menu[0].children[0].url : ''
      }
      resDetail = await getCateDetail({
        language: locale,
        url: activedCate,
        context,
      });
    }
    // @ts-ignore
    // current = parseInt(params?.slug?.[0] as string) || 1;

    const listRes = await getPostList({
      language: locale,
      categoryId: isAllList ? '' : resDetail?.data?.id,
      pageSize: size,
      pageNum: current,
      context,
    })
    list = listRes?.data?.items || []
    total = listRes?.data?.totalCount || 0;
  } else if (res && res?.code == 0 && type == 'detail') {
    let desc = res?.data?.postDetail?.content || ''
    const  detailList = desc.match(/<h2\s*[^>]*>(.*?)<\/h2>/g)?.map(item => item.replace(/<[^>]+>/g, '')) || []
    const  detailArrs = desc.match(/<h2\s*[^>]*>(.*?)<\/h2>/g) || []
    var newContent = desc
    detailArrs.forEach((item, i) => {
      var newItem = item.replace(/<h2(\s*[^>]*)>(.*?)<\/h2>/g, `<h2 id="${'articleTitle' + (i + 1)}" $1 >$2<\/h2>`)
      newContent = newContent.replace(item, newItem)
    })
    const post = {
      ...(res?.data?.postDetail || {}),
      content: newContent
    }
    dataInfo = {
      post,
      previousPost: res?.data?.previousPost || '',
      nextPost: res?.data?.nextPost || '' ,
      readMores:  res?.data?.readMores,
      detailList
    }
  }

  return {
    props: {
      ...(await serverSideTranslations(locale || 'en', [
        "common",
        "nav",
        "blog",
        "home",
        "footer",
        "nav",
        "home",
        "about",
      ])),
      blogs,
      menu,
      dataInfo,
      actived,
      list,
      resDetail,
      activedCate,
      type,
      total,
      current,
      size,
      isAllList
    },
  };
};

export default PostsList;
